export default "__VITE_ASSET__sPvUq7ak__"